"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationTypeEnum = void 0;
var IntegrationTypeEnum;
(function (IntegrationTypeEnum) {
    IntegrationTypeEnum["PERSONIO"] = "personio";
})(IntegrationTypeEnum || (exports.IntegrationTypeEnum = IntegrationTypeEnum = {}));
